module.exports = __webpack_public_path__ + "static/media/Constable.c251c913.jpg";